import VkEventsDropdown from "./VkEventsDropdown";
export default VkEventsDropdown;